import React from "react";
import PredictionCard from "../PredictionCard";

// Memoize PredictionCard to prevent unnecessary re-renders
const MemoizedPredictionCard = React.memo(PredictionCard);

/**
 * Component for rendering the list of matches with prediction cards
 * @param {Object} props - Component props
 * @param {Array} props.matches - Array of matches to render
 * @param {Array} props.availableMarkets - Available markets for predictions
 * @param {Array} props.summary - Match summaries
 * @param {Array} props.userPredictions - User's existing predictions
 * @param {Object} props.currentScores - Current scores for matches
 * @param {Function} props.onScoreSet - Handler for score changes
 * @param {Object} props.fansUnitedSDK - FansUnited SDK instance
 * @returns {JSX.Element} - List of prediction cards
 */
const MatchesList = ({ matches, availableMarkets, summary, userPredictions, currentScores, onScoreSet, fansUnitedSDK, canMakePredictions }) => {
	return (
		<div id="matches-list">
			{matches.map((match) => (
				<MemoizedPredictionCard
					key={match.id}
					match={match}
					markets={availableMarkets}
					summary={summary?.filter((s) => s.matchId === match.id)}
					userPredictions={userPredictions?.filter((p) => p.matchId === match.id)}
					currentScore={currentScores[match.id] || { homeTeamScore: 0, awayTeamScore: 0 }}
					onScoreSet={onScoreSet}
					fansUnitedSDK={fansUnitedSDK}
					canMakePredictions={canMakePredictions}
				/>
			))}
		</div>
	);
};

export default MatchesList;
